import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import ValidationTopErrorMessage from '../../portal/controls/validationTopErrorMessage';
import PortalTextBox from '../../portal/portalTextBox';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';
import AddEditUserScrollbars from './addEditUserScrollbars';
import styles from './style.scss';

@inject('translationsStore', 'oidcStore', 'usersStore', 'inviteUserStore', 'systemLocalesStore', 'passwordPoliciesStore', 'rolesStore') @observer
export default class InviteUserGeneralForm extends Component {
    fieldsWidth = '325px';

    constructor(props) {

        super(props);
        this.props.passwordPoliciesStore.updatePasswordPolicies(this.props.oidcStore.currentUser.profile.tenant_name);
        this.state = {
            generatedPassword: ''
        };
    }

    handleChangeUserName = e => this.props.inviteUserStore.setUserName(e.target.value);
    handleUserNameOnBlur = e => this.props.inviteUserStore.validateUserName();

    handleChangeEmail = e => this.props.inviteUserStore.setEmail(e.target.value);
    handleEmailOnBlur = e => this.props.inviteUserStore.validateEmail();

    handleChangeRoleId = (e, index, roleId) => {

        this.props.inviteUserStore.setRoleId(roleId);
    }

    getUserNameField() {

        return <div>
            <PortalTextBox
                hintText={this.props.translationsStore.translate('USER_NAME')}
                floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('USER_NAME')}
                    required={!this.shouldFieldDisabled} />}
                onChange={this.handleChangeUserName}
                onBlur={this.handleUserNameOnBlur}
                errorText={this.props.inviteUserStore.userNameValidationMessage}
                disabled={this.props.inviteUserStore.creatingUser || this.shouldFieldDisabled}
                value={this.props.inviteUserStore.values.userName}
                width={this.fieldsWidth}
            />
        </div>;
    }

    render() {

        const { values } = this.props.inviteUserStore;
        let userNameField = this.getUserNameField();

        return (
            <div>
                <ValidationTopErrorMessage errorMessage={this.props.inviteUserStore.addUserErrorMessage} />
                <AddEditUserScrollbars
                    height='60vh'
                >
                    <div>
                        <div
                            className={classNames(styles.userFormWrapper)}
                        >
                            {userNameField}
                            <div>
                                <PortalTextBox
                                    hintText={this.props.translationsStore.translate('EMAIL')}
                                    floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('EMAIL')} required />}
                                    onChange={this.handleChangeEmail}
                                    onBlur={this.handleEmailOnBlur}
                                    errorText={this.props.inviteUserStore.emailValidationMessage}
                                    disabled={this.props.inviteUserStore.creatingUser}
                                    value={values.email}
                                    width={this.fieldsWidth}
                                />
                            </div>
                            
                        </div>
                    </div>
                    <button type='submit' style={{ display: 'none' }} />
                </AddEditUserScrollbars>
            </div>
        );
    }
}